import React, {Component} from 'react';
import {Molecules} from "./Molecules";
import {SolarSystem} from "./SolarSystem";

export class Simulations extends Component {
    static displayName = Simulations.name;

    constructor(props) {
        super(props);
        this.state = {selected: 0};
    }

    selectSimulation = (index) => {
        this.setState({selected: index});
    }

    render() {
        const simulations = [
            {name: "Info", simulation: () => <p>Vælg en simulation ovenfor.</p>},
            {name: "Molekyler", simulation: () => <Molecules/>},
            {name: "Solsystem", simulation: () => <SolarSystem/>},
        ];
        const content = simulations[this.state.selected].simulation();
        return (
            <div>
                {simulations.map((simulation, index) =>
                    <input key={simulation.name} type="button" value={simulation.name}
                           onClick={() => this.selectSimulation(index)} className="btn btn-primary m-1"/>
                )}
                {content}
            </div>
        );
    }
}
